import { BaseService } from './base.service';

export default class PaymentSubscriptionService extends BaseService {
  public async getPaymentSubscriptionDetails(id: string | number) {
    return this.axios.get(`${this.backendUrl}/team/${id}/payment-subscription`, {});
  }

  public async updateMembers(id: string | number, members: number) {
    return this.axios.post(`${this.backendUrl}/team/${id}/payment-subscription/manage-members`, { members });
  }

  public async cancelSubscription(id: string | number) {
    return this.axios.post(`${this.backendUrl}/team/${id}/payment-subscription/cancel`, {});
  }

  public async getInvoice(teamId: string | number, invoiceId: string) {
    return this.axios.get(`${this.backendUrl}/team/${teamId}/payment-subscription/invoice/${invoiceId}`, {});
  }

  public async getInvoices(teamId: string | number) {
    return this.axios.get(`${this.backendUrl}/team/${teamId}/payment-subscription/invoices`, {});
  }

  public async getBilling(teamId: string | number) {
    return this.axios.get(`${this.backendUrl}/team/${teamId}/payment-subscription/billing`, {});
  }
}
